const translationKeys = {
  pending_payments_completed_payments_title:
    'pending_payments_completed_payments_title',
  pending_payments_export_to_excel_button_text:
    'pending_payments_export_to_excel_button_text',
  pending_payments_help_button_text: 'pending_payments_help_button_text',
  pending_payments_title: 'pending_payments_title',
  pending_payments_print_out_button_text:
    'pending_payments_print_out_button_text',
  pending_payments_actions_shortcut_button_title:
    'pending_payments_actions_shortcut_button_title',
  pending_payments_column_date: 'pending_payments_column_date',
  pending_payments_column_to: 'pending_payments_column_to',
  pending_payments_column_amount: 'pending_payments_column_amount',
  pending_payments_column_type: 'pending_payments_column_type',
  pending_payments_category_TRANSFER: 'pending_payments_category_TRANSFER',
  pending_payments_category_BUSINESS: 'pending_payments_category_BUSINESS',
  pending_payments_category_INDIVIDUAL: 'pending_payments_category_INDIVIDUAL',
  pending_payments_category_AVTALEGIRO: 'pending_payments_category_AVTALEGIRO',
  pending_payments_category_INTERNASJONAL:
    'pending_payments_category_INTERNASJONAL',
  pending_payments_category_DIGIPOST: 'pending_payments_category_DIGIPOST',
  pending_payments_category_EFAKTURA: 'pending_payments_category_EFAKTURA',
  pending_payments_category_MANUAL: 'pending_payments_category_MANUAL',
  pending_payments_category_LOAN: 'pending_payments_category_LOAN',
  pending_payments_category_OTHER: 'pending_payments_category_OTHER',
  pending_payments_status_ACTIVE: 'pending_payments_status_ACTIVE',
  pending_payments_status_STOPPED: 'pending_payments_status_STOPPED',
  pending_payments_status_PROCESSING: 'pending_payments_status_PROCESSING',
  pending_payments_status_READONLY: 'pending_payments_status_READONLY',
  pending_payments_status_PROCESSED: 'pending_payments_status_PROCESSED',
  pending_payments_status_LACK_OF_FUNDS:
    'pending_payments_status_LACK_OF_FUNDS',
  pending_payments_status_MUST_BE_AUTHORIZED:
    'pending_payments_status_MUST_BE_AUTHORIZED',
  pending_payments_status_OTHER: 'pending_payments_status_OTHER',
  pending_payments_status_detail_ACTIVE:
    'pending_payments_status_detail_ACTIVE',
  pending_payments_status_detail_REACTIVATED:
    'pending_payments_status_detail_REACTIVATED',
  pending_payments_status_detail_NO_FUNDS:
    'pending_payments_status_detail_NO_FUNDS',
  pending_payments_status_detail_IGNORE_AMOUNT_LIMIT:
    'pending_payments_status_detail_IGNORE_AMOUNT_LIMIT',
  pending_payments_status_detail_TECHNICAL_FAILURE:
    'pending_payments_status_detail_TECHNICAL_FAILURE',
  pending_payments_status_detail_STOPPED:
    'pending_payments_status_detail_STOPPED',
  pending_payments_status_detail_TX_LIMIT_EXCEEDED:
    'pending_payments_status_detail_TX_LIMIT_EXCEEDED',
  pending_payments_status_detail_AGREEMENT_SUSPENDED:
    'pending_payments_status_detail_AGREEMENT_SUSPENDED',
  pending_payments_status_detail_NO_FUNDS_STOPPED:
    'pending_payments_status_detail_NO_FUNDS_STOPPED',
  pending_payments_status_detail_NO_AGREEMENT:
    'pending_payments_status_detail_NO_AGREEMENT',
  pending_payments_status_detail_MAX_LIMIT_EXCEEDED:
    'pending_payments_status_detail_MAX_LIMIT_EXCEEDED',
  pending_payments_status_detail_NO_DISPOSAL:
    'pending_payments_status_detail_NO_DISPOSAL',
  pending_payments_status_detail_NOT_AUTHORIZED:
    'pending_payments_status_detail_NOT_AUTHORIZED',
  pending_payments_status_detail_DEB_ACCOUNT_INVALID:
    'pending_payments_status_detail_DEB_ACCOUNT_INVALID',
  pending_payments_status_detail_CRE_ACCOUNT_INVALID:
    'pending_payments_status_detail_CRE_ACCOUNT_INVALID',
  pending_payments_status_detail_CID_INVALID:
    'pending_payments_status_detail_CID_INVALID',
  pending_payments_status_detail_TECHNICAL_FAILURE_STOPPED:
    'pending_payments_status_detail_TECHNICAL_FAILURE_STOPPED',
  pending_payments_status_detail_BSU_YEAR_EXCEEDED:
    'pending_payments_status_detail_BSU_YEAR_EXCEEDED',
  pending_payments_status_detail_BSU_TOT_EXCEEDED:
    'pending_payments_status_detail_BSU_TOT_EXCEEDED',
  pending_payments_status_detail_BSU_AGE_EXCEEDED:
    'pending_payments_status_detail_BSU_AGE_EXCEEDED',
  pending_payments_status_detail_DUE_DATE_PROCESSING:
    'pending_payments_status_detail_DUE_DATE_PROCESSING',
  pending_payments_status_detail_READONLY:
    'pending_payments_status_detail_READONLY',
  pending_payments_status_detail_CANCELED_BY_BANK:
    'pending_payments_status_detail_CANCELED_BY_BANK',
  pending_payments_status_detail_VERIFICATION:
    'pending_payments_status_detail_VERIFICATION',
  pending_payments_status_detail_FRAUD: 'pending_payments_status_detail_FRAUD',
  pending_payments_status_detail_DEB_ACCOUNT_BLOCKED:
    'pending_payments_status_detail_DEB_ACCOUNT_BLOCKED',
  pending_payments_status_detail_KRE_ACCOUNT_BLOCKED:
    'pending_payments_status_detail_KRE_ACCOUNT_BLOCKED',
  pending_payments_status_detail_OTHER: 'pending_payments_status_detail_OTHER',
  pending_payments_category_PAYMENT: 'pending_payments_category_PAYMENT',
};

Object.freeze(translationKeys);

export default translationKeys;
